import React from 'react';

import { MdModeEdit, MdDelete, MdCheck } from 'react-icons/md';

import history from '~/services/history';

const columnAvc = () => {
  const editarLinha = (id, data) => {
    history.push({
      pathname: `/formulario-linhas-de-cuidado/${data.linhaDeCuidadoValue}`,
      state: {
        periodo: data.periodoSelecionado,
        indicador: data.linhaDeCuidadoValue,
        indicadorNome: data.linhaDeCuidado,
        idRecord: Number(id),
        id: Number(id),
      },
    });
  };

  const deletarLinha = (id, data) => {
    history.push({
      pathname: `/linha-de-cuidado/${data.linhaDeCuidadoValue}`,
      state: {
        periodo: data.periodoSelecionado,
        indicador: data.linhaDeCuidadoValue,
        indicadorNome: data.linhaDeCuidado,
        deleteLinha: Number(id),
      },
    });
  };

  return [
    {
      title: 'Número do registro',
      dataIndex: 'num_registro_avc',
      key: 'num_registro_avc',
      width: 170,
      sorter: (a, b) => a.num_registro_avc - b.num_registro_avc,
      sortDirections: ['descend', 'ascend'],
    },
    {
      title: 'Identificador do paciente',
      dataIndex: 'identificadordoPaciente',
      key: 'identificadordoPaciente',
      width: 210,
    },
    {
      title: 'Completo',
      key: 'completo',
      dataIndex: 'completo',
      width: 120,
      sorter: (a, b) => a.completo - b.completo,
      sortDirections: ['descend', 'ascend'],
      render: (id, data) => {
        return (
          <div>{data.completo && <MdCheck size={20} color="#74a50a" />}</div>
        );
      },
    },

    {
      title: '',
      key: 'id',
      dataIndex: 'id',
      width: 210,
      render: (id, data) => {
        return (
          <div className="botoesGrid">
            <button type="button" onClick={() => editarLinha(id, data)}>
              <MdModeEdit size={18} />
              Editar
            </button>
            <button
              type="button"
              className="btn-remove"
              onClick={() => deletarLinha(id, data)}
            >
              <MdDelete size={18} />
              Excluir
            </button>
          </div>
        );
      },
    },

    {
      title: 'Sexo',
      dataIndex: 'sexo_avc_descritivo',
      key: 'sexo_avc',
      width: 100,
    },

    {
      title: 'Data de nascimento',
      dataIndex: 'dn_avc',
      key: 'dn_avc',
      width: 120,
    },

    {
      title: 'Convênio do paciente',
      dataIndex: 'convenio_avc_descritivo',
      key: 'convenio_avc',
      width: 160,
    },

    {
      title: ' Tipo de AVC',
      dataIndex: 'classificacao_avc_descritivo',
      key: 'classificacao_avc',
      width: 160,
    },
    {
      title: 'Exame de imagem realizado',
      dataIndex: 'ex_imagem_avc_descritivo',
      key: 'ex_imagem_avc',
      width: 180,
    },

    {
      title: 'Data do início dos sintomas de AVC',
      dataIndex: 'sintomas_data_avc',
      key: 'sintomas_data_avc',
      width: 160,
    },
    {
      title: 'Hora do início dos sintomas de AVC',
      dataIndex: 'sintomas_hora_avc',
      key: 'sintomas_hora_avc',
      width: 160,
    },

    {
      title: 'Data da chegada na emergência',
      dataIndex: 'emergencia_data_avc',
      key: 'emergencia_data_avc',
      width: 130,
    },

    {
      title: 'Hora da chegada na emergência',
      dataIndex: 'emergencia_hora_avc',
      key: 'emergencia_hora_avc',
      width: 130,
    },

    {
      title: 'Pontuação da escala do NIHSS na admissão',
      dataIndex: 'nihss_resultado_avc',
      key: 'nihss_resultado_avc',
      width: 160,
    },
    {
      title: 'Unidade vascular',
      dataIndex: 'local_avc_uni_vasc_descritivo',
      key: 'local_avc_uni_vasc',
      width: 130,
    },
    {
      title: 'Emergência geral',
      dataIndex: 'local_avc_emer_geral_descritivo',
      key: 'local_avc_emer_geral',
      width: 180,
    },
    {
      title: 'Unidade de AVC',
      dataIndex: 'local_avc_uni_avc_descritivo',
      key: 'local_avc_uni_avc',
      width: 130,
    },

    {
      title: 'Neuro UTI ',
      dataIndex: 'local_avc_uti_neuro_descritivo',
      key: 'local_avc_uti_neuro',
      width: 130,
    },

    {
      title: 'UTI geral',
      dataIndex: 'local_avc_uti_geral_descritivo',
      key: 'local_avc_uti_geral',
      width: 130,
    },

    {
      title: ' Enfermaria geral',
      dataIndex: 'local_avc_enf_geral_descritivo',
      key: 'local_avc_enf_geral',
      width: 130,
    },

    {
      title: 'Trombólise intravenosa',
      dataIndex: 'reperfusao_avc_tiv_descritivo',
      key: 'reperfusao_avc_tiv',
      width: 130,
    },

    {
      title: 'Trombólise intra-arterial',
      dataIndex: 'reperfusao_avc_tia_descritivo',
      key: 'reperfusao_avc_tia',
      width: 130,
    },

    {
      title: 'Trombectomia mecânica',
      dataIndex: 'reperfusao_avc_trombec_descritivo',
      key: 'reperfusao_avc_trombec',
      width: 130,
    },

    {
      title: 'Data da realização da trombólise intravenosa',
      dataIndex: 'trombolise_data_avc',
      key: 'trombolise_data_avc',
      width: 180,
    },
    {
      title: 'Hora da realização da trombólise intravenosa',
      dataIndex: 'trombolise_hora_avc',
      key: 'trombolise_hora_avc',
      width: 180,
    },

    {
      title: 'Data da realização da trombectomia mecânica',
      dataIndex: 'trombectomia_data_avc',
      key: 'trombectomia_data_avc ',
      width: 180,
    },

    {
      title: 'Hora da realização da trombectomia mecânica ',
      dataIndex: 'trombectomia_hora_avc',
      key: 'trombectomia_hora_avc ',
      width: 180,
    },

    {
      title:
        'Diagnóstico de fibrilação atrial ou flutter atrial durante a internação',
      dataIndex: 'fa_avc_descritivo',
      key: 'fa_avc',
      width: 180,
    },

    {
      title: 'Recebeu triagem para disfagia',
      dataIndex: 'disfagia_avc_descritivo',
      key: 'disfagia_avc',
      width: 130,
    },

    {
      title: 'Pacientes em medidas de conforto ou cuidados paliativos',
      dataIndex: 'paliativos_avc_descritivo',
      key: 'paliativos_avc',
      width: 180,
    },

    {
      title: 'Recebeu antiagregante na alta',
      dataIndex: 'antiagregante_avc_descritivo',
      key: 'antiagregante_avc',
      width: 160,
    },

    {
      title: 'Recebeu anticoagulante na alta',
      dataIndex: 'anticoagulante_avc_descritivo',
      key: 'anticoagulante_avc',
      width: 160,
    },

    {
      title: 'Paciente teve diagnóstico de COVID-19 durante a internação',
      dataIndex: 'covid_avc_descritivo',
      key: 'covid_avc',
      width: 210,
    }, //

    {
      title: 'Motivo da saída hospitalar',
      dataIndex: 'saida_motivo_avc_descritivo',
      key: 'saida_motivo_avc',
      width: 180,
    },

    {
      title: 'Causa do óbito',
      dataIndex: 'obito_causa_avc_descritivo',
      key: 'obito_causa_avc',
      width: 130,
    },

    {
      title: 'Data da alta/óbito',
      dataIndex: 'saida_data_avc',
      key: 'saida_data_avc',
      width: 130,
    },

    {
      title: 'Hora da alta/óbito',
      dataIndex: 'saida_hora_avc',
      key: 'saida_hora_avc',
      width: 130,
    },

    {
      title: 'Pontuação no escore de Rankin modificado em 90 dias após o AVC',
      dataIndex: 'rankin_avc_descritivo',
      key: 'rankin_avc',
      width: 180,
    },
  ];
};

export default columnAvc;
